import React, {Fragment} from 'react';

class AnalysysDataViewTableParameterStation extends React.Component {

  render() {
    const {
      stations, selectedParameters, onChangeSelectedParameter,
      parameterStation1, parameterStation2, parameterStationExpanded, onClickExpandCollapse, func
    } = this.props;

    func.sort((a, b) => {
      if (a > b)
        return 1;
      else if (a < b)
        return -1;
      else
        return 0;
    });

    if (!parameterStation1.length) return null;

    return (<tbody>
    {
      func && func.length > 0 ?
      parameterStation1.map(level1Row => {
        return func.map(i => {
          const fun = i.toLowerCase();

          const caretDown = parameterStationExpanded[level1Row.id];
          const caretRight = !parameterStationExpanded[level1Row.id];

          return ([
            <tr key={`analysis-table-row-station-${level1Row.id}`}>
              <th className="caret" style={{width: '20px', marginTop: '2px'}}
                  onClick={() => onClickExpandCollapse(level1Row.id)}>
                {(caretDown === true) && (
                  <i className="fa fa-caret-down" aria-hidden="true"/>
                )}
                {(caretRight === true) && (
                  <i className="fa fa-caret-right" aria-hidden="true"/>
                )}
              </th>
              <th style={{left: '30px', width: '200px'}}>
                <div style={{fontWeight: 'bold'}}><input type='checkbox' checked={selectedParameters[level1Row.id]}
                                                         onChange={() => onChangeSelectedParameter(level1Row.id)}
                                                         style={{margin: '10px'}}/>{level1Row.name} ({i})</div>
              </th>
              {stations.map(station => <td key={`analysis-table-station-${station}-value`}>
                <div style={{
                  width: '130px',
                  textAlign: 'center'
                }}>{''}</div>
              </td>)}
            </tr>,
            ...(parameterStationExpanded[level1Row.id] && !!parameterStation2[level1Row.id] ? Object.keys(parameterStation2[level1Row.id]).sort((a, b) => new Date(a).valueOf() < new Date(b).valueOf() ? -1 : 1).map(key => {
              let rowData = parameterStation2[level1Row.id][key];
              return (
                <tr
                  key={`analysis-table-row-station-${rowData.level > 1 ? `${rowData.parent_id}-station-${rowData.id}-time-${rowData.time}` : rowData.id}`}>
                  <th className="caret" style={{width: '20px', marginTop: '2px'}}>{}</th>
                  <th style={{left: '30px', width: '200px'}}>{rowData.time}</th>
                  {
                    stations.map(station => <td key={`analysis-table-station-${station}-value`}>
                      <div style={{
                        width: '60px',
                        textAlign: 'center'
                      }}>{(!!rowData[fun][station] || rowData[fun][station] === 0) && rowData[fun][station]}</div>
                    </td>)}
                </tr>)
            }) : [])
          ])
        })
      }).reduce((acc, val) => {
        return [...acc, ...val];
      }, []) :
        parameterStation1.map(level1Row => {
          const caretDown = parameterStationExpanded[level1Row.id];
          const caretRight = !parameterStationExpanded[level1Row.id];

          return ([
            <tr key={`analysis-table-row-station-${level1Row.id}`}>
              <th className="caret" style={{width: '20px', marginTop: '2px'}}
                  onClick={() => onClickExpandCollapse(level1Row.id)}>
                {(caretDown === true) && (
                  <i className="fa fa-caret-down" aria-hidden="true"/>
                )}
                {(caretRight === true) && (
                  <i className="fa fa-caret-right" aria-hidden="true"/>
                )}
              </th>
              <th style={{left: '30px', width: '200px'}}>
                <div style={{fontWeight: 'bold'}}><input type='checkbox' checked={selectedParameters[level1Row.id]}
                                                         onChange={() => onChangeSelectedParameter(level1Row.id)}
                                                         style={{margin: '10px'}}/>{level1Row.name}</div>
              </th>
              {stations.map(station => <td key={`analysis-table-station-${station}-value`}>
                <div style={{
                  width: '130px',
                  textAlign: 'center'
                }}>{''}</div>
              </td>)}
            </tr>,
            ...(parameterStationExpanded[level1Row.id] && !!parameterStation2[level1Row.id] ? Object.keys(parameterStation2[level1Row.id]).sort((a, b) => new Date(a).valueOf() < new Date(b).valueOf() ? -1 : 1).map(key => {
              let rowData = parameterStation2[level1Row.id][key];
              return (
                <tr
                  key={`analysis-table-row-station-${rowData.level > 1 ? `${rowData.parent_id}-station-${rowData.id}-time-${rowData.time}` : rowData.id}`}>
                  <th className="caret" style={{width: '20px', marginTop: '2px'}}>{}</th>
                  <th style={{left: '30px', width: '200px'}}>{rowData.time}</th>
                  {
                    stations.map(station => <td key={`analysis-table-station-${station}-value`}>
                      <div style={{
                        width: '60px',
                        textAlign: 'center'
                      }}>{(!!rowData.data[station] || rowData.data[station] === 0) && rowData.data[station]}</div>
                    </td>)}
                </tr>)
            }) : [])
          ])
        })}</tbody>);
  }
}

export default AnalysysDataViewTableParameterStation;


// WEBPACK FOOTER //
// ./src/components/Analysis/Data/AnalysysDataViewTableParameterStation.js